import React from "react";
import { useResponsive } from "../../../hooks/mediaQuery";

type WaterParameter = {
    parameterName: string;
    parameterUnit: string;
    value: number | null;
    standardMin: number | null;
    standardMax: number | null;
}
type WaterCardProps = {
    param: WaterParameter;
    color: string;
    border: string;
    isWarning?: boolean;
}

function getStatusColor(value: number | null, min: number | null, max: number | null) {
    if (value === null || (min === null && max === null)) return "gray";
    if (max !== null && value > max) return "red";
    if (min !== null && value < min) return "red";
    if (max !== null && value >= 0.8 * max) return "orange"; // 80% threshold for warning
    if (min !== null && value <= 1.2 * min) return "orange"; // 20% below min for warning
    return "green";
}

const WaterCard: React.FC<WaterCardProps> = ({ param, color, border, isWarning }) => {
    const colorMap: any = {
        red: "#ff4d4f",
        yellow: "#faad14",
        green: "#52c41a",
        gray: "#bfbfbf",
    };

    const {isXs} = useResponsive();
    return (
        <div
            className={`flex-1 border border-gray-200 rounded-xl md:p-4 p-2 min-w-[170px] min-h-[80px] bg-white shadow-md flex flex-col justify-between ${isWarning ? 'border:animate-flash' : ''}`}
            style={{ border: `2px solid ${colorMap[border]}` }}
        >
            <div className="flex justify-between items-center">
                <span className={`font-semibold ${isWarning ? 'animate-flash' : ''}`} style={{ color: colorMap[border] }}>{param.parameterName}</span>
                <span
                    className="w-4 h-4 rounded-full inline-block"
                    style={{
                        borderRadius: "50%",
                        background: colorMap[color]
                    }}
                />
            </div>
            <div className="flex flex-wrap justify-between items-end md:gap-3">
                <div className={`${isXs ? 'text-xl' : 'text-2xl'} ${isWarning ? 'animate-flash' : ''} font-bold text-gray-800`} style={{ color: colorMap[border] }}>
                    {param.value !== null ? param.value : "--"}
                    <span className={`${isXs ? 'text-sm' : 'text-base'} font-normal ml-1 text-gray-600`} style={{ color: colorMap[border] }}>{param.parameterUnit}</span>
                </div>
                <div className={`${isXs ? 'text-xs' : 'text-sm'} text-gray-600`}>
                    {param.standardMax ? `Giới hạn: <=${param.standardMax}` : param.standardMin ? `Giới hạn: >= ${param.standardMin}` : "Không giới hạn"}
                </div>
            </div>
        </div>
    );
};

export default WaterCard;
